<!-- Define sizing constraints on the component instance -->

<template>
  <div 
    class="blur-tab-overlay relative"
    :style="{
      '--initial-tab-size': resolvedOptions.tabSize,
      '--hovered-tab-size': resolvedOptions.hoveredTabSize,
      '--transition-duration': resolvedOptions.transitionDuration,
      '--border-radius': resolvedOptions.borderRadius
    }"
    @contextmenu.prevent
  >
    <div class="w-full h-full pointer-events-none select-none" style="min-height: 200px;">
      <slot />
    </div>
    <div class="blur-layer" :class="resolvedOptions.tabPosition">
      <div class="tab-layer" :class="resolvedOptions.tabPosition" />
    </div>
  </div>
</template>

<script>
const DEFAULT_OPTIONS = {
  borderRadius: '12px',
  tabSize: '44px',
  hoveredTabSize: '134px',
  transitionDuration: '300ms',
  tabPosition: 'top-right'
}

export default {
  name: 'BaseBlurTabOverlay',
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      resolvedOptions: {
        ...DEFAULT_OPTIONS,
        ...this.options
      }
    }
  },
}
</script>

<style scoped>
@property --corner-cut {
  syntax: '<length>';
  inherits: true;
  initial-value: 0px;
}
.blur-tab-overlay {
  --corner-cut: var(--initial-tab-size);
  transition-property: --corner-cut;
  transition-timing-function: cubic-bezier(0.65, 0, 0.35, 1);
  transition-duration: var(--transition-duration);
}
.blur-tab-overlay:hover {
  --corner-cut: var(--hovered-tab-size);
}
.blur-layer {
  position: absolute;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.44);
  z-index: 10;
  backdrop-filter: blur(22px);
  border-radius: var(--border-radius);
}
.blur-layer.top-right {
  clip-path: polygon(
    0 0,
    calc(100% - var(--corner-cut)) 0,
    100% var(--corner-cut),
    100% 100%,
    0 100%
  );
}
.blur-layer.top-left {
  clip-path: polygon(
    var(--corner-cut) 0,
    100% 0,
    100% 100%,
    0 100%,
    0 var(--corner-cut)
  );
}
.blur-layer.bottom-right {
  clip-path: polygon(
    0 0,
    100% 0,
    100% calc(100% - var(--corner-cut)),
    calc(100% - var(--corner-cut)) 100%,
    0 100%
  );
}
.blur-layer.bottom-left {
  clip-path: polygon(
    0 0,
    100% 0,
    100% 100%,
    var(--corner-cut) 100%,
    0 calc(100% - var(--corner-cut))
  );
}
.tab-layer {
  position: absolute;
  width: calc(var(--corner-cut) + 8px);
  height: calc(var(--corner-cut) + 8px);
  background-color: white;
}
.tab-layer.top-right {
  top: -8px;
  right: -8px;
  border-bottom-left-radius: var(--border-radius);
  box-shadow: -2px 3px 7px -2px rgba(0, 0, 0, 0.12);
}
.tab-layer.top-left {
  top: -8px;
  left: -8px;
  border-bottom-right-radius: var(--border-radius);
  box-shadow: 2px 3px 7px -2px rgba(0, 0, 0, 0.12);
}
.tab-layer.bottom-right {
  bottom: -8px;
  right: -8px;
  border-top-left-radius: var(--border-radius);
  box-shadow: -2px -3px 7px -2px rgba(0, 0, 0, 0.12);
}
.tab-layer.bottom-left {
  bottom: -8px;
  left: -8px;
  border-top-right-radius: var(--border-radius);
  box-shadow: 2px -3px 7px -2px rgba(0, 0, 0, 0.12);
}
</style>